import { request } from "./request";

//获取任务情况
function getImgeTask(params) {
    return request({
        url: '/web/api/ai/task',
        method: 'GET',
        params
    })
}

//图片生成
function getImg(data) {
    return request({
        url: '/web/api/ai/generate',
        method: 'POST',
        data: data
    })
}

//图片生成记录列表
function getImgList(data) {
    return request({
        url: '/web/webUserGdataImage/selectListPage',
        method: 'POST',
        data: data
    })
}

//图片详情
function getImgDetail(data) {
    return request({
        url: '/web/webUserGdataImage/getWebUserGdataImage',
        method: 'POST',
        data
    })
}

//图片删除
function deleteImg(data) {
    return request({
        url: '/web/webUserGdataImage/delete',
        method: 'POST',
        data: data
    })
}

//token查询
function getTokenCnt(params) {
    return request({
        url: '/web/model/getModelRemainTokenCnt',
        method: 'GET',
        params
    })
}



export default {
    getImgeTask,
    getImg,
    getImgList,
    getImgDetail,
    deleteImg,
    getTokenCnt
}